var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 17.5V19.25C33.75 19.9501 33.75 20.3001 33.6138 20.5675C33.4939 20.8027 33.3027 20.9939 33.0675 21.1138C32.8001 21.25 32.4501 21.25 31.75 21.25H28.25C27.5499 21.25 27.1999 21.25 26.9325 21.1138C26.6973 20.9939 26.5061 20.8027 26.3862 20.5675C26.25 20.3001 26.25 19.9501 26.25 19.25V17.5M25.25 42.5H34.75C36.1501 42.5 36.8502 42.5 37.385 42.2275C37.8554 41.9878 38.2378 41.6054 38.4775 41.135C38.75 40.6002 38.75 39.9001 38.75 38.5V21.5C38.75 20.0999 38.75 19.3998 38.4775 18.865C38.2378 18.3946 37.8554 18.0122 37.385 17.7725C36.8502 17.5 36.1501 17.5 34.75 17.5H25.25C23.8499 17.5 23.1498 17.5 22.615 17.7725C22.1446 18.0122 21.7622 18.3946 21.5225 18.865C21.25 19.3998 21.25 20.0999 21.25 21.5V38.5C21.25 39.9001 21.25 40.6002 21.5225 41.135C21.7622 41.6054 22.1446 41.9878 22.615 42.2275C23.1498 42.5 23.8499 42.5 25.25 42.5Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerIcon);
export default __webpack_public_path__ + "static/media/partnerIcon.0d20e36a1e85215785978311d00adc18.svg";
export { ForwardRef as ReactComponent };